import { render, staticRenderFns } from "./reports-heading.vue?vue&type=template&id=4e452b27&scoped=true"
import script from "./reports-heading.vue?vue&type=script&lang=js"
export * from "./reports-heading.vue?vue&type=script&lang=js"
import style0 from "./reports-heading.vue?vue&type=style&index=0&id=4e452b27&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e452b27",
  null
  
)

export default component.exports